import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { SharedModule } from 'src/app/shared/shared.module';

import { CalendarComponent } from './calendar.component';
import { CalendarFiltersComponent } from './calendar-filters/calendar-filters.component';
import { CalendarUserFilterComponent } from './calendar-filters/calendar-user-filter/calendar-user-filter.component';
import { CalendarUserDistanceFilterComponent } from './calendar-filters/calendar-user-distance-filter/calendar-user-distance-filter.component';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
import { UserCalendarComponent } from './user-calendar/user-calendar.component';
import { EventDetailsModalComponent } from './user-calendar/event-details-modal/event-details-modal.component';
import { CalendarConflictCheckComponent } from './calendar-conflict-check/calendar-conflict-check.component';

@NgModule({
    declarations: [
        CalendarComponent,
        CalendarFiltersComponent,
        CalendarUserFilterComponent,
        CalendarUserDistanceFilterComponent,
        CalendarHeaderComponent,
        UserCalendarComponent,
        EventDetailsModalComponent,
        CalendarConflictCheckComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        SchedulerModule,
        ButtonsModule,
        DropDownsModule,
        InputsModule,
        LabelModule,
        LayoutModule,
        TooltipsModule,
    ],
    exports: [
        CalendarComponent,
        CalendarFiltersComponent,
        CalendarUserFilterComponent,
        CalendarUserDistanceFilterComponent,
        CalendarHeaderComponent,
        UserCalendarComponent,
        EventDetailsModalComponent,
        CalendarConflictCheckComponent,
    ]
})
export class CalendarModule { }
